import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CustomerSummary } from "./customer/CustomerSummary";
import { CustomerList } from "./customer/CustomerList";
import { CustomerDebtors } from "./customer/CustomerDebtors";
import { CustomerVIP } from "./customer/CustomerVIP";
import { CustomerBehavior } from "./customer/CustomerBehavior";
import { CustomerInsights } from "./customer/CustomerInsights";
import { Button } from "@/components/ui/button";
import { Download, Send } from "lucide-react";
import { toast } from "sonner";

export function CustomerReport() {
  const { data: customers, isLoading: isLoadingCustomers } = useQuery({
    queryKey: ["customers-report"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("customers")
        .select(`
          *,
          transactions (
            id,
            amount,
            payment_status,
            payment_method,
            created_at,
            type
          )
        `);

      if (error) throw error;
      return data;
    },
  });

  const handleExportReport = () => {
    // TODO: Implement export functionality
    toast.info("Funcionalidade de exportação em desenvolvimento");
  };

  const handleSendWhatsApp = () => {
    // TODO: Implement WhatsApp integration
    toast.info("Integração com WhatsApp em desenvolvimento");
  };

  if (isLoadingCustomers) {
    return <div>Carregando relatório...</div>;
  }

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold text-[#004080]">Relatório de Clientes</h2>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="gap-2"
            onClick={handleExportReport}
          >
            <Download className="h-4 w-4" />
            Exportar
          </Button>
          <Button
            variant="outline"
            className="gap-2"
            onClick={handleSendWhatsApp}
          >
            <Send className="h-4 w-4" />
            WhatsApp
          </Button>
        </div>
      </div>

      <div className="grid gap-6">
        <CustomerSummary data={customers} />
        
        <Card>
          <CardHeader>
            <CardTitle>Lista de Clientes</CardTitle>
          </CardHeader>
          <CardContent>
            <CustomerList data={customers} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Clientes Inadimplentes</CardTitle>
          </CardHeader>
          <CardContent>
            <CustomerDebtors data={customers} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Clientes VIP</CardTitle>
          </CardHeader>
          <CardContent>
            <CustomerVIP data={customers} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Análise de Comportamento</CardTitle>
          </CardHeader>
          <CardContent>
            <CustomerBehavior data={customers} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Insights e Ações</CardTitle>
          </CardHeader>
          <CardContent>
            <CustomerInsights data={customers} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}